(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shopify が自動生成するラッパー要素 <div id="shopify-section-{id}" class="shopify-section featured-blog-posts">
    // をフックにするため、既存のセクション内マークアップには一切手を加えていません。
    var WRAPPER_SELECTOR = '.shopify-section.featured-blog-posts';
    var TRIGGER_SELECTOR = '[data-infinite-scroll-trigger]';
    var STATUS_SELECTOR = '[data-infinite-scroll-status]';
    var ITEM_SELECTOR = '.resource-list__item';

    function initWrapper(wrapper) {
      if (!wrapper || wrapper.dataset.infiniteScrollInitialized === 'true') return;

      var trigger = wrapper.querySelector(TRIGGER_SELECTOR);
      if (!trigger) return;

      wrapper.dataset.infiniteScrollInitialized = 'true';

      // id="shopify-section-123456789" -> "123456789"
      var sectionId = wrapper.id.replace('shopify-section-', '');
      var status = wrapper.querySelector(STATUS_SELECTOR);
      var isLoading = false;
      var observer = null;

      function announce(message) {
        if (status) status.textContent = message;
      }

      function setLoading(state) {
        isLoading = state;
        trigger.setAttribute('aria-busy', state ? 'true' : 'false');
      }

      function stopObserving() {
        if (observer) observer.disconnect();
      }

      function loadNextPage() {
        if (isLoading) return;
        var href = trigger.getAttribute('href');
        if (!href) return;

        setLoading(true);
        announce('読み込み中です…');

        var url = new URL(href, window.location.href);
        url.searchParams.set('section_id', sectionId);

        fetch(url.toString())
          .then(function (response) {
            if (!response.ok) throw new Error('network error');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll(ITEM_SELECTOR);
            var existingItems = wrapper.querySelectorAll(ITEM_SELECTOR);
            var lastItem = existingItems[existingItems.length - 1];
            var container = lastItem ? lastItem.parentNode : null;

            if (container) {
              newItems.forEach(function (item) {
                container.appendChild(document.importNode(item, true));
              });
            }

            var newTrigger = doc.querySelector(TRIGGER_SELECTOR);
            if (newTrigger) {
              trigger.setAttribute('href', newTrigger.getAttribute('href'));
            } else {
              stopObserving();
              trigger.remove();
            }

            announce(
              newItems.length
                ? newItems.length + '件の投稿を追加で読み込みました'
                : 'すべての投稿を表示しました'
            );
          })
          .catch(function () {
            announce('投稿の読み込み中にエラーが発生しました。もう一度お試しください。');
          })
          .finally(function () {
            setLoading(false);
          });
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        loadNextPage();
      });

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) loadNextPage();
            });
          },
          { rootMargin: '600px 0px 0px 0px' }
        );
        observer.observe(trigger);
      }
    }

    function initAll() {
      document.querySelectorAll(WRAPPER_SELECTOR).forEach(initWrapper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // テーマエディタでセクションが再読み込みされた際に再初期化
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
